import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const legal = [
  { to: "/privacidad", label: "Política de Privacidad" },
  { to: "/aviso-legal", label: "Aviso Legal" },
  { to: "/cookies", label: "Cookies" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1F3A] text-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <Link to="/" className="text-2xl font-serif font-semibold tracking-tight">Medite Group</Link>
          <p className="mt-6 text-white/60 leading-relaxed max-w-sm">
            No vendemos servicios. Resolvemos retos empresariales y nos convertimos en parte de tu negocio.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-[#0B1F3A] px-7 py-3.5 text-sm font-medium hover:scale-[1.03] transition-transform"
          >
            Solicitar un diagnóstico inicial <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="lg:col-span-3 lg:col-start-8">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Contacto</div>
          <ul className="space-y-3 text-white/75 text-sm">
            <li><a href="mailto:info@meditegroup.com" className="hover:text-white transition-colors">info@meditegroup.com</a></li>
            <li>Barcelona, 08019</li>
            <li>España</li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Legal</div>
          <ul className="space-y-3">
            {legal.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-legal-${l.to.replace("/", "")}`} className="text-white/75 hover:text-white transition-colors text-sm">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-white/10 text-sm text-white/40">
        © {new Date().getFullYear()} Medite Group. Consultoría para empresas · Barcelona, España.
      </div>
    </div>
  </footer>
);

export default Footer;
